import request from '@/utils/request2'

/**
 * 
 * @returns 获取频度列
 */
export function getsfAllList() {
  return request({
    url: '/ltcloud/frequency/getAllList',
    method: 'post'
  })
}
export function getXiangMuList() {
  return request({
    url: '/maApp/getList',
    method: 'post'
  })
}
export function getListByAppId(data) {
  return request({
    url: '/maAppGroup/getListByAppId',
    method: 'post',
    params: data
  })
}
export function getYYByXmId(data) {
  return request({
    url: '/maApp/getInfo',
    method: 'post',
    params: data
  })
}
export function getZtByZtId(data) {
  return request({
    url: '/maAppGroup/getInfo',
    method: 'post',
    params: data
  })
}
export function getAppInfo(data) {
  return request({
    url: '/maApp/getInfo',
    method: 'post',
    params: data
  })
}

export function getDataSource(data) {
  return request({
    url: '/maDataSource/getList',
    method: 'post',
    params: data
  })
}
//获取用户信息
export function getUserInfo() {
  return request({
    url: '/ltcloud/user/info',
    method: 'post',

  })
}

//添加日志
export function save(data) {
  return request({
    url: '/maOperateLog/save',
    method: 'post',
    data
  })
}

/**
 * 主题服务树
 * @param data
 * @return {*}
 */
export function getInitialLoading(data) {
  return request({
    url: '/maAppGroup/getListByAppId',
    method: 'post',
    params: data
  })
}

/**
 * 所有主题树
 * @param data
 * @return {*}
 */
export function getAllTree(data) {
  return request({
    url: '/maAppGroup/getAllTree',
    method: 'post',
    data
  })
}

/**
 * 所有主题树
 * @param data
 * @return {*}
 */
export function getAppList() {
  return request({
    url: '/maApp/getAppList',
    method: 'post'
  })
}

/**
 * 所有主题树
 * @param data
 * @return {*}
 */
export function getList() {
  return request({
    url: '/maApp/getList',
    method: 'post'
  })
}

export function getId() {
  return request({
    url: '/ltcloud/user/getId',
    method: 'post'
  })
}

export function getAllUser() {
  return request({
    url: '/ltcloud/user/getAllUser',
    method: 'post'
  })
}